define(["jquery", "bootstrap/modal", "mage/translate"], function ($, Modal, __) {
    "use strict";

    // Event reference
    // When signup opens via button click - newsletter:signup:open
    // When user quits signup without submission - newsletter:signup:quit

    return function (KlaviyoComponent) {
        return KlaviyoComponent.extend({
            preventPopupUrlParams: {
                utm_medium: "email"
            },
            showPopupUrlParams: {
                showPopup: "true" // "?showPopup=true" will not match "{showPopup: true}"
            },

            initialize: function (config, element) {
                this._super();
                this.configureModal();
                if (this.objectMatchesUrlParam(this.showPopupUrlParams)) {
                    const modal = new Modal(this.element);
                    modal.show();
                }
            },

            modalShown: function () {
                $.event.trigger("newsletter:signup:open");
            },

            modalHidden: function () {
                this.klaviyoExtraProperties.$source = this.formSource;

                if (!this.isFormSubmitted) {
                    $.event.trigger("newsletter:signup:quit");
                }
            },

            configureModal: function () {
                $(this.element)
                    .on("shown.bs.modal", this.modalShown)
                    .on("hidden.bs.modal", this.modalHidden.bind(this));

                // eslint-disable-next-line no-new
                new Modal(this.element, {
                    show: false
                });
            }
        });
    };
});
